import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Logo from "../components/Logo";
import client from "../lib/api";

export default function WinPage() {
  const { token } = useParams();
  const [win, setWin] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { client.get(`/public/win/${token}`).then((r) => setWin(r.data.win)).catch(() => setErr(true)); }, [token]);
  const title = win ? `First load booked — ${win.lane_from} → ${win.lane_to}` : "First load booked";
  useEffect(() => { document.title = `${title} · FreightPilot AI`; }, [title]);
  return (
    <div className="min-h-screen bg-neutral-950 text-white noise-bg" data-testid="win-page">
      <header className="max-w-3xl mx-auto px-4 sm:px-8 py-6 flex items-center justify-between"><Link to="/"><Logo /></Link></header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 pb-16">
        {err && <div className="card-surface p-8 text-neutral-400" data-testid="win-page-error">This win card isn't available.</div>}
        {win && (
          <>
            <img src={`${process.env.REACT_APP_BACKEND_URL}/api/public/win/${win.token}/card.png`} alt={title} className="w-full max-w-lg mx-auto rounded-2xl border border-white/10" data-testid="win-page-image" />
            <div className="text-center mt-8">
              <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight" data-testid="win-page-title">{(win.company || win.first_name || "A new owner-operator")} just booked their first load.</h1>
              <p className="text-neutral-400 mt-3 text-sm sm:text-base">Waiting on your MC? The free checklist tracks it on FMCSA, texts you the day it goes ACTIVE, and hands you a 7-day plan to your first load.</p>
              <Link to="/mc" className="btn-primary rounded-full px-6 py-3 mt-6 inline-flex items-center gap-2 text-sm" data-testid="win-page-cta">Get the free checklist <ArrowRight size={16} weight="bold" /></Link>
            </div>
          </>
        )}
      </main>
    </div>
  );
}
